module.exports = __webpack_public_path__ + "img/solicitud-finalizada.9bfcd0f6.jpeg";